<script setup>
    import { defineProps, defineEmits, computed, nextTick } from 'vue'

    const emit = defineEmits(['update:modelValue'])

    const props = defineProps({
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },

        max: {
            type: Number,
            required: false,
            default: () => Infinity
        },

        canSetQuantity: {
            type: Function,
            required: false,
            default: () => () => true
        },
        
        canDecrement: {
            type: Boolean,
            default: () => true
        },

        canIncrement: {
            type: Boolean,
            default: () => true
        },

        modelValue: {
            type: Number,
            default: () => 0
        }
    })

    const quantity = computed({
        get() {
            return props.modelValue
        },

        set(value) {
            console.log('setQuantity', value)
            setQuantity(value)
        }
    })

    const increment = () => {
        emit('update:modelValue', props.modelValue + 1)
    }

    const decrement = () => {
        emit('update:modelValue', props.modelValue - 1)
    }

    const setQuantity = ($event) => {
        const value = Number($event.target.value)
        emit('update:modelValue', value)
        nextTick(() => {
            if (Number($event.target.value) !== props.modelValue) {
                $event.target.value = props.modelValue
            }
        })
    }
</script>

<template>
    <div class="storefront__quantity-picker">
        <button
            v-if="modelValue > 0"
            type="button"
            class="storefront__quantity-picker__button storefront__quantity-picker__button--decrement"
            @click="decrement"
            :disabled="disabled || !canDecrement"
        >
            <font-awesome-icon icon="minus" />
        </button>

        <input
            v-if="modelValue > 0"
            class="storefront__quantity-picker__input"
            type="number"
            :min="1"
            :max="max"
            inputmode="numeric"
            :disabled="disabled"
            :value="props.modelValue"
            @input="setQuantity"
        >

        <button
            type="button"
            class="storefront__quantity-picker__button storefront__quantity-picker__button--increment"
            @click="increment"
            :disabled="disabled || !canIncrement"
        >
            <font-awesome-icon icon="plus" />
        </button>
    </div>
</template>